import React, { createContext, useContext, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress'; // Material-UI spinner
import Backdrop from '@mui/material/Backdrop'; // Material-UI backdrop for overlay

// Create a Context
const ProgressBarContext = createContext();

// ProgressBarProvider Component
export const ProgressBarProvider = ({ children }) => {
    const [loading, setLoading] = useState(false); // Track loading state

    // Function to toggle progress bar visibility
    const showProgress = (show) => {
        setLoading(show);
    };

    return (
        <ProgressBarContext.Provider value={{ showProgress }}>
            {/* Progress Indicator */}
            <Backdrop
                open={loading}
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            {children} {/* Render children components */}
        </ProgressBarContext.Provider>
    );
};

// Hook to use the ProgressBarContext
export const useProgressBar = () => {
    const context = useContext(ProgressBarContext);
    if (!context) {
        throw new Error("useProgressBar must be used within a ProgressBarProvider");
    }
    return context;
};
